import { FC } from 'react';

/** @deprecated */
const LinkIcon: FC = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.2769 8.89589L11.344 8.96299C11.9534 9.57235 12.9412 9.57235 13.5505 8.96299L16.6441 5.87015C17.5539 4.95962 17.5539 3.47016 16.6441 2.55963L15.2725 1.18876C14.3627 0.278227 12.8725 0.278227 11.9628 1.18876L8.86913 4.2816C8.25977 4.89096 8.25977 5.87874 8.86913 6.48888L8.93623 6.5552"
      stroke="#1C85E8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.3757 8.11572L7.3086 8.0494C6.69924 7.43926 5.71147 7.43926 5.10211 8.0494L2.00849 11.1422C1.09873 12.0528 1.09873 13.5422 2.00849 14.4528L3.38013 15.8236C4.28988 16.7342 5.78013 16.7342 6.68988 15.8236L9.7835 12.7308C10.3929 12.1207 10.3929 11.1329 9.7835 10.5235L9.7164 10.4564"
      stroke="#1C85E8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.29199 11.5413L12.3599 5.47266"
      stroke="#1C85E8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// oxlint-disable-next-line typescript/no-deprecated -- Existing screens still import this icon while the icon migration is pending
export default LinkIcon;
